import { render, staticRenderFns } from "./VulnerabilitiesTable.vue?vue&type=template&id=1706d90e&"
import script from "./VulnerabilitiesTable.vue?vue&type=script&lang=js&"
export * from "./VulnerabilitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports